import i18n from "../../i18n";

/* 뉴스·블로그 글의 표시 언어 선택
   - 영문판(EN)에서 title_en / content_en 이 있으면 그것을 사용
   - 없으면 국문 원문을 그대로 보여줍니다 */
export const isEnglish = () => i18n.language === "en";

export const postTitle = (post) =>
  (isEnglish() && post?.title_en) || post?.title || "";

export const postContent = (post) =>
  (isEnglish() && post?.content_en) || post?.content || "";

// 기계 번역본을 보고 있는지 (안내 문구 표시용)
export const isMachineTranslated = (post) =>
  Boolean(isEnglish() && post?.title_en);
